module.exports = __webpack_public_path__ + "img/atemoya-350x184.3c1138fb.jpg";